import React, { useEffect, useState } from 'react';
import ApacheEcharts from '../../ApacheEcharts';
import "./GraficoBarra.css";

function GraficoBarra({ dadosGrafico }) {

    const { titulo, dados, mesAno } = dadosGrafico;
    const { mes, ano } = mesAno;

    const [option, setOption] = useState({});
    const style = { width: "100%", height: "200px", padding: "0px" };

    useEffect(() => {
        const servicos = ['servico'];
        const realizado = ['Valor'];
        const series = [];

        for (let i = 0; i < dados.length; i++) {
            servicos.push(dados[i]['servico']);
            realizado.push(dados[i]['realizado']);
            series.push({ type: 'bar', itemStyle: { borderRadius: [6, 6, 0, 0] } });
        }

        const option = {
            color: ['#165BAA', '#1AB394', '#F9C74F', '#F3722C', '#F0125C', '#80D50D'],
            grid: {
                width: '48%',
                height: '80%',
                left: '13%',
                top: '10%'
            },
            tooltip: {
                trigger: "item",
                valueFormatter: (value) => parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                axisPointer: {
                    type: "shadow"
                }
            },
            legend: {
                icon: 'circle',
                right: '1%',
                orient: 'vertical',
                top: '10%',
                textStyle: {
                    fontSize: 11
                }
            },
            xAxis: {
                show: false,
                type: 'category',
            },
            yAxis: { type: 'value' },
            axisLabel: {
                formatter: function (value) {
                    var val = formatarValores(value);
                    return val;
                },
            },
            series: series,
            dataset: {
                source: [servicos, realizado]
            },
        }

        setOption(option);

    }, [dados]);

    function formatarValores(valor) {
        if (valor >= 1000000) {
            return (valor / 1000000).toFixed(1) + "M";
        } else if (valor >= 1000) {
            return (valor / 1000).toFixed(0) + "K";
        } else {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        }
    }

    function formatarNomeMes(numeroMes) {
        const mes = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];

        return mes[numeroMes - 1];
    }

    return (
        <div className='card-barra'>
            <div className='card-header-barra font-titulo-barra'>
                <h4 className='uppercase'>{titulo}</h4>
                <span className='text-[10px]' style={{ color: '#888888' }}>{formatarNomeMes(mes)} {ano}</span>
            </div>
            {dados.length > 0 ? (
                <ApacheEcharts option={option} style={style} />
            ) : (
                <p className='p-info-barra font-titulo-barra'>Sem dados no momento!</p>
            )}
        </div>
    );
}

export default GraficoBarra